import { render, staticRenderFns } from "./BaseH2.vue?vue&type=template&id=2a2186a3&scoped=true"
import script from "./BaseH2.vue?vue&type=script&lang=js"
export * from "./BaseH2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2186a3",
  null
  
)

export default component.exports